
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp-ai-chatbot",
      function () {
        return require("private-next-pages/whatsapp-ai-chatbot.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp-ai-chatbot"])
      });
    }
  